import styled from 'styled-components';

export const StyledTariffUnitQuantityWrapperDiv = styled.div`
  vertical-align: top;
  display: inline-block;
  .ant-input-number-disabled {
    background: transparent;
  }
`;

export const StyledUomQuantityDiv = styled.div`
  display: inline-block;
`;
